import { ERoundState, IRoundBet, IRoundGetStateData } from "../interfaces";
import { EntityState } from "@ngrx/entity";

export namespace RoundState {
    export const featureKey: string = "round";
}

export interface IRoundState {
    roundId: string | undefined;
    state: ERoundState;
    bets: EntityState<IRoundBet>;
    totalBets: number;
    multiplier: number;
    userBets: IUserBet[];
    autoplayOptions: IAutoplayOptions[];
    initialRoundState: IRoundGetStateData | undefined;
}

export interface ISendBetArgs {
    amount: number;
    betIndex: number;
    maxMultiplier: number | undefined;
}

export interface IUserBet {
    roundId: string | undefined;
    amount: number;
    accumulatedValue: number;
    multiplier: number;
    betIndex: number;
    maxMultiplier: number | undefined;
    firstHalfCashedOut: number | undefined;
}

export interface IAutoplayOptions {
    betArgs: ISendBetArgs;
    roundCount: number;
    initialRoundCount: number;
    initialWalletAmount: number;
    cashOutInRound: boolean;
    maxStackDecreaseAmount: number | undefined;
    maxStackIncreaseAmount: number | undefined;
    maxAccumulatedAmount: number | undefined;
}
